import { OAuthOpenOptions, OAuthProvider, Provider } from 'cio/utils/oauth';

interface OpenOptions extends OAuthOpenOptions {
  authorizationURL: string;
  clientID: string;
}

export default class AzureOIDCOauth extends OAuthProvider {
  name = Provider.AzureOIDC;
  baseUrl = '';
  clientId = '';
  scope = 'email openid profile';
  extraParams = {};

  async open({ authorizationURL, clientID, ...rest }: OpenOptions) {
    this.baseUrl = authorizationURL;
    this.clientId = clientID;

    let res;

    try {
      res = await super.open(rest);
    } finally {
      this.baseUrl = '';
      this.clientId = '';
    }

    return res;
  }
}
